import React from "react";
import SuperAdminForm from "./SuperAdminForm";
import { useMutation } from "react-query";
import { createErrors } from "../../../queries/helpers";
import PropTypes from "prop-types";
import { createSuperAdmin } from "../../../queries/admin/superAdmin";
import { useErrorHandler } from "react-error-boundary";

const NewSuperAdminPage = ({ history, toast }) => {
  const handleError = useErrorHandler();
  const newSuperAdmin = useMutation(async (formData) => {
    await createSuperAdmin(formData);
  });

  const onSubmit = async (values) => {
    values["password_confirmation"] = values.password;
    return await newSuperAdmin
      .mutateAsync(values)
      .then(() => {
        toast.success([
          {
            title: "Super Admin has been created",
            body: values.fullName,
          },
        ]);
        history.push("/super-admins");
      })
      .catch((error) => {
        toast.error([
          {
            title: "Failed to create super admin",
            body: `${error.response.data.errors
              .map((error) => error.detail)
              .join(", ")}`,
          },
        ]);
        return createErrors(error, "Failed to create super admin", handleError);
      });
  };
  return <SuperAdminForm onSubmit={onSubmit} />;
};

NewSuperAdminPage.propTypes = {
  history: PropTypes.object.isRequired,
  toast: PropTypes.func.isRequired,
};

export default NewSuperAdminPage;
